/*CSS IMPORTS*/
import 'Common/Components/ArticleTitle/articleTitle.css'
const Title = (props) => {
    return (
        <h2 className="title">{props.children}</h2>
    );
}

export default Title;